<template>
<div>
    <Breadcrumbs main="Admin" submain="Course" title="Course" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <router-link :to="{ name: 'courseCreate' }">
                            <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Course</h7>
                            </button>
                        </router-link>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="course_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="min-width: 200px; max-width: 400px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7>{{ row.item.title }}</h7>
                                            <h7 v-if="row.item.link">
                                                <a
                                                    :href="row.item.link"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style="
                                                        display: inline-block;
                                                        padding: 2px 14px;
                                                        border-radius: 999px;
                                                        background: #f0f4ff;
                                                        color: #2563eb;
                                                        text-decoration: underline;
                                                        font-weight: 500;
                                                        font-size: 13px;
                                                        transition: background 0.2s;
                                                    "
                                                >
                                                    View Course
                                                </a>
                                            </h7>
                                        </div>
                                    </template>

                                    <template #cell(category)="row">
                                        <div v-if="row.item.category" style="min-width: 200px; display: flex; flex-direction: column; gap: 2px;">
                                            <h7>{{ row.item.category?.title }}</h7>
                                            <h7 v-if="row.item.sub_category">Sub: {{ row.item.sub_category?.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(cost)="row">
                                        <div style="min-width: 200px; max-width: 300px; display: flex; flex-direction: column; gap: 2px;">
                                            <h7>
                                                <b-badge :variant="row.item.own_asset ? 'success' : 'info'">
                                                    {{ row.item.own_asset ? 'Own Course' : 'External' }}
                                                </b-badge>
                                            </h7>
                                            <h7 style="margin-top: 4px" v-if="row.item.coin_cost && row.item.coin_cost !== 0"><span style="margin-top: 2px">Cost:</span> <b-badge>{{ row.item.coin_cost }}</b-badge></h7>
                                        </div>
                                    </template>

                                    <template #cell(partner)="row">
                                        <div v-if="row.item.own_asset === false && row.item.partner" style="min-width: 200px;">
                                            <a :href="row.item.partner?.link" target="_blank" rel="noopener noreferrer">
                                                <h7 style="font-size: 14px; font-weight: 500;">{{ row.item.partner?.title }}</h7>
                                            </a>
                                        </div>
                                        <div v-else>
                                            <!-- <h7 style="font-size: 14px; font-weight: 500;">QuickCV</h7> -->
                                        </div>
                                    </template>

                                    <template #cell(thumbnail)="row">
                                        <div v-if="row.item.thumbnail" style="min-width: 120px;">
                                            <img style="max-height: 80px;" :src="host + row.item.thumbnail" alt="">
                                        </div>
                                    </template>

                                    <!-- <template #cell(banner)="row">
                                        <div v-if="row.item.banner" style="min-width: 120px;">
                                            <img style="max-height: 80px;" :src="host + row.item.banner" alt="">
                                        </div>
                                    </template> -->

                                    <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_on.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_on.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCourse(data.item.slug)" title="Delete"></feather>
                                            </div>
                                            <div>
                                                <router-link :to="{ name: 'courseEdit', params: { slug: data.item.slug } }">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                                </router-link>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Course Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this course?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'category',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'cost',
                    label: 'Cost',
                    sortable: true
                },
                {
                    key: 'partner',
                    label: 'Partner',
                    sortable: true
                },
                {
                    key: 'thumbnail',
                    label: 'Thumbnail',
                    sortable: true
                },
                // {
                //     key: 'banner',
                //     label: 'Banner',
                //     sortable: true
                // }, 
                // {
                //     key: 'created_on',
                //     label: 'Created On',
                //     sortable: true
                // },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            course_list: state => state.course.course,
            loading: state => state.course.courseLoading,
            error: state => state.course.courseError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("course/fetchCourse").then(() => {
            this.items = this.course_list
            this.totalRows = this.course_list?.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems?.length;
            this.currentPage = 1;
        },

        deleteCourse(slug) {
            this.delete_value = slug
        },

        handleDeleteOk() {
            this.$store.dispatch("course/deleteCourse", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
